import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type PostProductionJobsMutationVariables = Types.Exact<{
  input: Types.PostProductionJobsInput;
}>;


export type PostProductionJobsMutation = { __typename?: 'Mutation', postProductionJobs: { __typename?: 'PostProductionJobsPayload', results: Array<{ __typename?: 'PostProductionJobResult', productionJobId: string, inventoryPost: Types.ProductionPostingStageStatus, reservationPeg: Types.ProductionPostingStageStatus, productionLot?: { __typename?: 'ProductionLotStateData', productionLotId: string, closedStatus: Types.LotClosedStatus, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, postingStatus: Types.JobPostingStatus } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ReopenProductionJobMutationVariables = Types.Exact<{
  input: Types.ReopenProductionJobDataInput;
}>;


export type ReopenProductionJobMutation = { __typename?: 'Mutation', reopenProductionJob: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', productionLotId: string, closedStatus: Types.LotClosedStatus, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, postingStatus: Types.JobPostingStatus } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AdjustPostedProductionMutationVariables = Types.Exact<{
  input: Types.AdjustPostedProductionDataInput;
}>;


export type AdjustPostedProductionMutation = { __typename?: 'Mutation', adjustPostedProduction: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', productionLotId: string, closedStatus: Types.LotClosedStatus, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, postingStatus: Types.JobPostingStatus } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ConsumeProductionJobsMaterialsMutationVariables = Types.Exact<{
  input: Types.ConsumeProductionJobsMaterialsInput;
}>;


export type ConsumeProductionJobsMaterialsMutation = { __typename?: 'Mutation', consumeProductionJobsMaterials: { __typename?: 'ConsumeProductionJobsMaterialsPayload', results: Array<{ __typename?: 'ConsumeProductionJobMaterialsResult', productionJobId: string, productionLot?: { __typename?: 'ProductionLotStateData', productionLotId: string, closedStatus: Types.LotClosedStatus, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, postingStatus: Types.JobPostingStatus } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RepairProductionJobReservationPegsMutationVariables = Types.Exact<{
  input: Types.RepairProductionJobReservationPegsInput;
}>;


export type RepairProductionJobReservationPegsMutation = { __typename?: 'Mutation', repairProductionJobReservationPegs: { __typename?: 'RepairProductionJobReservationPegsPayload', results: Array<{ __typename?: 'RepairProductionJobReservationPegResult', productionJobId: string, reservationPeg: Types.ProductionPostingStageStatus, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const PostProductionJobsDocument = new TypedDocumentString(`
    mutation PostProductionJobs($input: PostProductionJobsInput!) {
  postProductionJobs(input: $input) {
    results {
      productionJobId
      inventoryPost
      reservationPeg
      productionLot {
        ...ProductionLotPostingLifecycle
      }
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotPostingLifecycle on ProductionLotStateData {
  productionLotId
  closedStatus
  finishJob {
    productionJobId
    postingStatus
  }
}`);
export const ReopenProductionJobDocument = new TypedDocumentString(`
    mutation ReopenProductionJob($input: ReopenProductionJobDataInput!) {
  reopenProductionJob(input: $input) {
    productionLot {
      ...ProductionLotPostingLifecycle
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotPostingLifecycle on ProductionLotStateData {
  productionLotId
  closedStatus
  finishJob {
    productionJobId
    postingStatus
  }
}`);
export const AdjustPostedProductionDocument = new TypedDocumentString(`
    mutation AdjustPostedProduction($input: AdjustPostedProductionDataInput!) {
  adjustPostedProduction(input: $input) {
    productionLot {
      ...ProductionLotPostingLifecycle
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotPostingLifecycle on ProductionLotStateData {
  productionLotId
  closedStatus
  finishJob {
    productionJobId
    postingStatus
  }
}`);
export const ConsumeProductionJobsMaterialsDocument = new TypedDocumentString(`
    mutation ConsumeProductionJobsMaterials($input: ConsumeProductionJobsMaterialsInput!) {
  consumeProductionJobsMaterials(input: $input) {
    results {
      productionJobId
      productionLot {
        ...ProductionLotPostingLifecycle
      }
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotPostingLifecycle on ProductionLotStateData {
  productionLotId
  closedStatus
  finishJob {
    productionJobId
    postingStatus
  }
}`);
export const RepairProductionJobReservationPegsDocument = new TypedDocumentString(`
    mutation RepairProductionJobReservationPegs($input: RepairProductionJobReservationPegsInput!) {
  repairProductionJobReservationPegs(input: $input) {
    results {
      productionJobId
      reservationPeg
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    PostProductionJobs: build.mutation<PostProductionJobsMutation, PostProductionJobsMutationVariables>({
      query: (variables) => ({ document: PostProductionJobsDocument, variables })
    }),
    ReopenProductionJob: build.mutation<ReopenProductionJobMutation, ReopenProductionJobMutationVariables>({
      query: (variables) => ({ document: ReopenProductionJobDocument, variables })
    }),
    AdjustPostedProduction: build.mutation<AdjustPostedProductionMutation, AdjustPostedProductionMutationVariables>({
      query: (variables) => ({ document: AdjustPostedProductionDocument, variables })
    }),
    ConsumeProductionJobsMaterials: build.mutation<ConsumeProductionJobsMaterialsMutation, ConsumeProductionJobsMaterialsMutationVariables>({
      query: (variables) => ({ document: ConsumeProductionJobsMaterialsDocument, variables })
    }),
    RepairProductionJobReservationPegs: build.mutation<RepairProductionJobReservationPegsMutation, RepairProductionJobReservationPegsMutationVariables>({
      query: (variables) => ({ document: RepairProductionJobReservationPegsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { usePostProductionJobsMutation, useReopenProductionJobMutation, useAdjustPostedProductionMutation, useConsumeProductionJobsMaterialsMutation, useRepairProductionJobReservationPegsMutation } = injectedRtkApi;
